export enum DOMEventType {
    CLICK = 'CLICK',
    RESIZE = 'RESIZE',
    SCROLL = 'SCROLL'
}
